"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const calendar = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-calendar` : '') + (description ? ` desc-calendar` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-calendar"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-calendar"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_972_1962)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.5 5.25a.75.75 0 0 0-.75-.75H2.25a.75.75 0 0 0-.75.75v16.5a.75.75 0 0 0 .75.75h19.5a.75.75 0 0 0 .75-.75V5.25Zm1.5 16.5A2.25 2.25 0 0 1 21.75 24H2.25A2.25 2.25 0 0 1 0 21.75V5.25A2.25 2.25 0 0 1 2.25 3h19.5A2.25 2.25 0 0 1 24 5.25v16.5Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.25 9a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h22.5Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 6V.75a.75.75 0 0 1 1.5 0V6A.75.75 0 0 1 6 6Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.5 6V.75a.75.75 0 0 1 1.5 0V6a.75.75 0 0 1-1.5 0Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 13.88a.38.38 0 0 1-.38.37V15a1.13 1.13 0 0 1-.8-1.92l.1-.08c.2-.16.44-.25.7-.25v.75c.08 0 .15.02.21.06l.06.05.05.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.75 13.88A1.13 1.13 0 0 1 5.62 15v-.75a.38.38 0 0 1-.26-.64l.06-.05a.37.37 0 0 1 .2-.06v-.75c.27 0 .52.1.72.25l.08.08.08.08c.16.2.25.45.25.71Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6 19.13a.38.38 0 0 1-.38.37v.75a1.13 1.13 0 0 1-.8-1.92l.1-.08c.2-.16.44-.25.7-.25v.75c.08 0 .15.02.21.06l.06.05.05.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.75 19.13a1.13 1.13 0 0 1-1.13 1.12v-.75a.38.38 0 0 1-.26-.64l.06-.05a.37.37 0 0 1 .2-.06V18c.27 0 .52.1.72.25l.08.08.08.08c.16.2.25.45.25.71Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.38 13.88a.38.38 0 0 1-.38.37V15a1.13 1.13 0 0 1-.8-1.92l.09-.08c.2-.16.45-.25.71-.25v.75c.07 0 .15.02.2.06l.07.05.04.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.13 13.88A1.13 1.13 0 0 1 12 15v-.75a.38.38 0 0 1-.27-.64l.06-.05a.37.37 0 0 1 .21-.06v-.75c.26 0 .51.1.71.25l.09.08.07.08c.16.2.26.45.26.71Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.38 19.13a.38.38 0 0 1-.38.37v.75a1.13 1.13 0 0 1-.8-1.92l.09-.08c.2-.16.45-.25.71-.25v.75c.07 0 .15.02.2.06l.07.05.04.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.13 19.13A1.13 1.13 0 0 1 12 20.25v-.75a.38.38 0 0 1-.27-.64l.06-.05a.37.37 0 0 1 .21-.06V18c.26 0 .51.1.71.25l.09.08.07.08c.16.2.26.45.26.71Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.75 13.88a.38.38 0 0 1-.38.37V15a1.13 1.13 0 0 1-.8-1.92l.1-.08c.2-.16.44-.25.7-.25v.75c.08 0 .15.02.21.06l.06.05.05.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.5 13.88A1.13 1.13 0 0 1 18.37 15v-.75a.38.38 0 0 1-.26-.64l.06-.05a.37.37 0 0 1 .2-.06v-.75c.27 0 .52.1.72.25l.08.08.08.08c.16.2.25.45.25.71Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.75 19.13a.38.38 0 0 1-.38.37v.75a1.13 1.13 0 0 1-.8-1.92l.1-.08c.2-.16.44-.25.7-.25v.75c.08 0 .15.02.21.06l.06.05.05.06c.04.06.06.13.06.2Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.5 19.13a1.13 1.13 0 0 1-1.13 1.12v-.75a.38.38 0 0 1-.26-.64l.06-.05a.37.37 0 0 1 .2-.06V18c.27 0 .52.1.72.25l.08.08.08.08c.16.2.25.45.25.71Z",
    fill: "black"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_972_1962"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
var _default = exports.default = calendar;